import {useMemo} from 'react';
import {RawTariffDto} from '../../../global/api';
import {useGetBillingTariffsQuerySuspense} from '../../../global/services/billing';

export const useTariffs = () => {
  const {data, refresh} = useGetBillingTariffsQuerySuspense(null);
  const plans = useMemo<RawTariffDto[]>(
    () => [...(data ?? [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)),
    [data],
  );

  return {
    plans,
    refreshTariffs: refresh,
  };
};
